import { useEffect, useState } from "react";
import { useNotify } from "react-admin";
import { API_BASE_URL_ADMIN } from "shared/config";
import { API_URL } from "shared/constants/api-url";
import { ERROR_MSG } from "shared/constants/error-msg";
import { httpClient } from "shared/services/http-client";
import { isForbiddenError } from "shared/utils/errors";

interface Arguments {
  companyId: string;
}

export const useGetCompanyRoles = ({ companyId }: Arguments) => {
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState<string[]>([]);
  const notify = useNotify();

  const url = API_URL.getCompanyRoles(companyId);

  const fetchCompanyRoles = () => {
    setIsLoading(true);

    return httpClient(`${API_BASE_URL_ADMIN}${url}`, {
      method: 'GET',
    })
    .then((response) => {
      const roles = response.json.roles;

      setRoles(roles);

      return roles;
    })
    .catch((error) => {
      let msg = error.message || ERROR_MSG.internal

      if (isForbiddenError(error)) {
        msg = ERROR_MSG.forbidden
      }

      notify(msg, { type: 'error' });
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchCompanyRoles();
  }, []);

  return { fetchCompanyRoles, isLoading, roles };
};